import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import { Alert } from 'antd'
import './VideoPlayer.css'
import { getTokenFromLocalStorage } from 'services/loginService'
import $t from '../../../../i18n'
import { APP_ENV } from 'utils/envUtils'

const getSystemId = id => `p_${id}`

export const VideoPlayer = ({
  roomName,
  accessToken,
  appointment,
  onCompleted,
  onError,
  onEnd,
  setStatus
}) => {
  const videoRef = useRef(null)
  const userDetails = useSelector(state => state.profile.userDetails)
  const [networkInfo, setNetworkInfo] = useState(5)
  const participantInfo = appointment?.participants.find(
    p => p.type === 'patient' && p.id === getSystemId(userDetails.id)
  )

  useEffect(() => {
    window.addEventListener('message', onMessage)

    return () => window.removeEventListener('message', onMessage)
  }, [])

  useEffect(() => {
    if (accessToken && roomName) {
      setStatus('connecting')
    }
  }, [accessToken, roomName])

  const onMessage = e => {
    if (e?.data?.message === 'Room completed') {
      onCompleted()
    } else if (e?.data?.message === 'Requested from Calls FE') {
      //message when video init
      // send message to iframe to connect auto
      if (videoRef?.current && videoRef?.current?.contentWindow) {
        videoRef?.current.contentWindow.postMessage(
          { message: 'Auto connect', accessToken },
          '*'
        )
      }
    } else if (e?.data?.message === 'Camera and mic allowed') {
      let iframe = document.getElementById('inlineFrameExample')
      iframe.src = iframe.src
    } else if (
      e?.data?.message !== ('Room completed' || 'Requested from Calls FE')
    ) {
      setStatus('connected')
      setNetworkInfo(e?.data?.message)
    }
  }
  const renderNetworkAlert = () => {
    if (networkInfo <= 2)
      return (
        <Alert
          message={$t('VideoCall.message')}
          type='error'
          className='video-alert'
        />
      )
    else return null
  }

  const getVideoCallUrl = () => {
    const params = new URLSearchParams()
    params.append('token', getTokenFromLocalStorage())

    let baseUrl = `https://${window.location.hostname}`

    if (APP_ENV === 'local') {
      baseUrl = `http://${window.location.hostname}:3002`
    }
    const roomUrl = new URL(
      `${baseUrl}` +
        `/calls-frontend/room/${roomName}/${participantInfo?.id}/${participantInfo?.name}`
    )

    roomUrl.search = params.toString()
    return roomUrl
  }

  return (
    <div className='video-container'>
      <iframe
        ref={videoRef}
        id='inlineFrameExample'
        title='Inline Frame Example'
        style={{ width: '100%', height: '100%', border: 'none' }}
        onError={onError}
        src={getVideoCallUrl()}
        allow='camera *;microphone *'
      ></iframe>
      {renderNetworkAlert()}
      <Button type='primary' className='end-call' onClick={onEnd}>
        Disconnect
      </Button>
    </div>
  )
}

export default VideoPlayer
